const TRANSLATION_KEY_FIELDS = [
    'title',
    'pretitle',
    'description',
    'text',
    'prefix',
    'description_key',
    'header',
    'from_name',
    'from_initials',
    'from_address',
    'subject',
    'to_name',
    'to_address',
    'extra_to_string',
];

const TRANSLATION_VALUE_FIELD_KEYS = new Set([
    ...TRANSLATION_KEY_FIELDS,
    'description_key',
]);

/** User-facing copy used as i18n keys — not colors, URLs, or static asset paths. */
export function isTranslatableStringValue(value) {
    if (typeof value !== 'string') return false;
    const trimmed = value.trim();
    if (!trimmed) return false;
    if (/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/.test(trimmed)) {
        return false;
    }
    if (/^rgba?\(/i.test(trimmed)) return false;
    if (/^\/static\//i.test(trimmed)) return false;
    if (/^https?:\/\//i.test(trimmed)) return false;
    if (
        /\.(svg|png|jpe?g|gif|webp|ico)(\?.*)?$/i.test(trimmed) &&
        !/\s/.test(trimmed)
    ) {
        return false;
    }
    return true;
}

function collectStringsFromValue(value, out, fieldKey = null) {
    if (value == null) return;
    if (typeof value === 'string') {
        if (
            fieldKey &&
            TRANSLATION_VALUE_FIELD_KEYS.has(fieldKey) &&
            isTranslatableStringValue(value)
        ) {
            out.add(value.trim());
        }
        return;
    }
    if (Array.isArray(value)) {
        value.forEach((item) => collectStringsFromValue(item, out, null));
        return;
    }
    if (typeof value === 'object') {
        Object.keys(value).forEach((key) => {
            collectStringsFromValue(value[key], out, key);
        });
    }
}

export function questionDefinitionToTranslationKeys(definition) {
    const out = new Set();
    let def;
    if (typeof definition === 'string') {
        try {
            def = JSON.parse(definition);
        } catch {
            return [];
        }
    } else if (definition && typeof definition === 'object') {
        if (
            definition.ui &&
            typeof definition.ui === 'object' &&
            definition.definition == null
        ) {
            // LMS preview API exposes `ui` at top level (definition cleared server-side).
            def = { ui: definition.ui };
        } else if (definition.definition != null) {
            if (typeof definition.definition === 'string') {
                try {
                    def = JSON.parse(definition.definition);
                } catch {
                    return [];
                }
            } else {
                def = definition.definition;
            }
        } else {
            def = definition;
        }
    } else {
        return [];
    }

    if (def?.ui) {
        collectStringsFromValue(def.ui, out);
    }

    return [...out].sort();
}
